import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { StakinglistPage } from './stakinglist';

@NgModule({
  declarations: [
    StakinglistPage,
  ],
  imports: [
    IonicPageModule.forChild(StakinglistPage),
  ],
})
export class StakinglistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/stakinglist/stakinglist.module.ts